import React, { useEffect, useState } from "react";
import PublicLayout from "@/components/PublicLayout";
import MoodboardsGrid from "@/components/MoodboardsGrid";
import { api } from "@/lib/api";

export default function Moodboards() {
  const [moodboards, setMoodboards] = useState([]);
  useEffect(() => {
    api.get("/moodboards").then((r) => setMoodboards(r.data)).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <section className="pt-32 md:pt-40 pb-8">
        <div className="max-w-[1500px] mx-auto px-5 md:px-10">
          <div className="eyebrow mb-4">The Palette · {moodboards.length} Moodboards</div>
          <h1 className="font-display italic text-5xl md:text-8xl leading-[0.95] tracking-tight max-w-3xl">
            Colour, texture, light.
          </h1>
          <p className="mt-6 max-w-xl text-[color:var(--text-muted)]">
            Every wedding begins here — a set of references and moods pinned into a single image before a single flower is ordered.
          </p>
        </div>
      </section>
      <MoodboardsGrid moodboards={moodboards} dense />
    </PublicLayout>
  );
}
